<template>
    <div>

        <v-row>
            <v-col>
                <datePickerForm
                    label="Fecha"
                    :valueInput="values.date"
                    :rule="rules.required"
                    @valueChange="(v) => {values.date = v; delete serverErrors['date']}"
                    :errorMessages="serverErrors['date']"
                ></datePickerForm>
            </v-col>
        </v-row>


        <v-row>
            <v-col class="py-2">
                <autocompleteOneForm
                    label="Cliente"
                    :loading="loadingClients"
                    :valueInput="values.receiver_id"
                    :rule="rules.required"
                    :items="serverItems.clients"
                    :errorMessages="serverErrors.receiver_id"
                    @valueChange="(v) => {values.receiver_id = v; delete serverErrors.receiver_id}"
                ></autocompleteOneForm>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="py-2">
                <autocompleteOneForm
                    label="OT"
                    :loading="loadingReferences"
                    :valueInput="values.reference_id"
                    :rule="rules.required"
                    :items="serverItems.references"
                    :errorMessages="serverErrors.reference_id"
                    @valueChange="(v) => {values.reference_id = v; delete serverErrors.reference_id}"
                ></autocompleteOneForm>
            </v-col>
        </v-row>


        <v-row>
            <v-col class="py-2" cols="12" md="6">
                <autocompleteOneForm
                    label="Divisa"
                    :valueInput="values.currency"
                    :rule="rules.required"
                    :items="serverItems.currencies"
                    :errorMessages="serverErrors.currency"
                    @valueChange="(v) => {values.currency = v; delete serverErrors.currency}"
                ></autocompleteOneForm>
            </v-col>

            <v-col class="py-2">
                <autocompleteOneForm
                    label="Método de pago"
                    :loading="loadingPM"
                    :valueInput="values.payment_method"
                    :rule="rules.required"
                    :items="serverItems.paymentsMethods"
                    :errorMessages="serverErrors.payment_method"
                    @valueChange="(v) => {values.payment_method = v; delete serverErrors.payment_method}"
                ></autocompleteOneForm>
            </v-col>

        </v-row>

        <v-row>
            <v-col class="py-2" cols="12" md="6">
                <autocompleteOneForm
                    label="Tipo de comprobante"
                    :loading="loadingCfdiTypes"
                    :valueInput="values.cfdi_name_id"
                    :rule="rules.required"
                    :items="serverItems.cfdiTypes"
                    :errorMessages="serverErrors.cfdi_name_id"
                    @valueChange="(v) => {values.cfdi_name_id = v; delete serverErrors.cfdi_name_id}"
                ></autocompleteOneForm>
            </v-col>

            <v-col class="py-2">
                <autocompleteOneForm
                    label="Forma de pago"
                    :loading="loadingPaymentForms"
                    :valueInput="values.payment_form"
                    :rule="rules.required"
                    :items="serverItems.paymentForms"
                    :errorMessages="serverErrors.payment_form"
                    @valueChange="(v) => {values.payment_form = v; delete serverErrors.payment_form}"
                ></autocompleteOneForm>
            </v-col>

        </v-row>

        <v-row>
             <v-col class="py-2">
                <textFieldForm 
                    @valueChange="(v) => {values.comments = v; delete serverErrors.comments}" 
                    :valueInput="values.comments" 
                    :rule="[]" 
                    label="Comentarios"
                    :errorMessages="serverErrors.comments"
                ></textFieldForm>
            </v-col>
        </v-row>


        <v-row>
            <v-col class="py-0">
                <h4>Partidas</h4>
            </v-col>
        </v-row>

        <v-row>
            <v-col class="py-2">
                <div class="sale-bill-form-product-select-container">
                    <autocompleteOneForm
                        class="full-width"
                        label="Concepto de la partida"
                        :loading="loadingProducts"
                        :valueInput="productSelected"
                        :rule="[]"
                        :items="serverItems.products"
                        @valueChange="(v) => {productSelected = v;}"
                    ></autocompleteOneForm>
                    <iconButton class="ml-2" :props="addBtnData" ></iconButton>
                </div>
            </v-col>
            
        </v-row>


        <v-row key="keyTable">
            <v-col>
                <table-items  :props="tableProps" @methodHandler="method_handler" :items="values.items" :class="`${tableClass}`">
                   
                    <template v-slot:item.quantity="props">
                        <div class="table-item">
                            <v-text-field class="custom-sale-bill-input" :rules="rules.quantity"  v-model="props.item.quantity" @keyup="() => {calcItem(props.item)}"></v-text-field>
                        </div>
                    </template>

                    <!-- <template v-slot:item.unit_price="props">
                        <div class="table-item">
                            <span>{{ut.currencyFormat(props.item.unit_price, props.item.currency)}}</span>
                        </div>
                    </template> -->


                    <template v-slot:item.description="props">
                        <!-- <div class="table-item">
                            <v-text-field :rules="rules.required"  v-model="props.item.description"></v-text-field>
                        </div> -->

                        <v-menu  v-model="props.item.parameters.showMenu" top offset-y :close-on-click="false" :close-on-content-click="false" max-height="500">
                            <template v-slot:activator="{ on, attrs }">
                                <div @click="() => {setTableClass(true, props.item)}" class="table-item small-th-always" v-on="on" v-bind="attrs">
                                    <span>{{ props.item.description }}</span>
                                </div>
                            </template>
                            <div>
                                <v-card width="500">
                                    <v-card-text>
                                        <textAreaForm
                                            
                                            label="concepto"
                                            :rules="rules.required"  
                                            @valueChange="(v) => {props.item.description = v}" 
                                            :valueInput="props.item.description" 
                                            :rows="1"
                                        ></textAreaForm>
                                    </v-card-text>
                                   <div class="sale-bill-textarea-input-btn">
                                        
                                        <v-btn
                                            width="40%"
                                            class="mx-auto"
                                            color="black"
                                            outlined
                                            @click="() => {cancelItemDesc(props.item)}"
                                            >
                                            Cancelar
                                        </v-btn>
                                        <v-btn
                                            width="40%"
                                            class="mx-auto"
                                            color="primary"
                                            depressed
                                            @click="() => {closeItemDesc(props.item)}"
                                            >
                                            <span class="black--text">Aceptar</span>
                                        </v-btn>
                                   </div>
                                </v-card>
                            </div>
                        </v-menu>
                    </template>

                    <template v-slot:item.unit_price="props">
                        <div class="table-item">
                            <v-text-field prefix="$" class="custom-sale-bill-input" :suffix="values.currency" :rules="rules.current_mxn_per_usd"  v-model="props.item.unit_price" @keyup="() => {calcItem(props.item)}"></v-text-field>
                        </div>
                    </template>

                    <template v-slot:item.iva="props">
                        <div class="table-item">
                            <div v-for="(item, index) in props.item.taxes" :key="index" class="">
                                <div class="sale-bill-tax-item px-3 small-th-always">
                                    <p class="mb-0 font-weight-bold">{{item.name}} ({{ut.getPercentage(item.rate, 1)}}%)</p>
                                    <p class="mb-0">{{ut.currencyFormat(item.total, values.currency)}}</p>
                                </div>
                               
                            </div>
                            
                        </div>
                    </template>

                    <template v-slot:item.total="props">
                        <div class="table-item">
                            <span>{{ut.currencyFormat(props.item.total, values.currency)}}</span>
                        </div>
                    </template>
                   
                </table-items>
                <!-- <v-input class="warning--text caption" :error-messages="serverErrors.balanceables" v-model="values.balanceables" :rules="rules.balanceables"></v-input> -->
            </v-col>
        </v-row>
        
        






    </div>
</template>

<script>
import TableItems from "../incomes/TableItems.vue";
import Utils from '../../helpers/Utils';

/* eslint-disable */
export default {
    props: ['values', 'serverErrors', 'edit', 'inputCreditNotes'],
    components: {
       'table-items': TableItems
    },
    data(){
        return {
            keyTable: 4443,
            tableClass: "",
            ut: Utils,
            loadingClients: false,
            loadingReferences: false,
            loadingPM: false,
            loadingCfdiTypes: false,
            loadingPaymentForms: false,
            loadingProducts: false,
            productSelected: "",
            backupConcept: "",


            addBtnData: {
                hasTooltip:true,
                tooltip: 'Agregar',
                color:'grey darken-4',
                iconColor:'primary',
                height:'38',
                icon: "mdi-plus",
				to: "",
				block: false,
                click: ()=>{this.addProduct()}
            },
            
           
            rules: {
				required: [
					v => !!v || 'El campo requerido'
				],
               
                amount: [
                    v => {
                        if(v!= null && !v.toString().match("^[0-9]+(\.[0-9]{1,4})?$"))
                            return 'Solo números válidos';
                        if(v === null || v.toString().trim() === '')
                            return 'El campo es requerido'
                        return true;
                    }
                ],

                requiredIva: [
                    v => {
                        if(this.values.ObjetoImp == 2)
                            return 'El campo es requerido'
                        return true;
                    }
                ],
               
				current_mxn_per_usd: [
                    v => {
                        if(v!= null && !v.toString().match("^[0-9]+(\.[0-9]{1,4})?$"))
                            return 'Solo números válidos';
                        if(v === null || v.toString().trim() === '')
                            return 'El campo es requerido';
                        // if(v === 0 || v === '0' || v<=0)
                        //     return 'El campo debe ser máyor a 1';
                        return true;
                    }
                ],
            },
            serverItems: {
                references:[ 
                ],
                products:[ 
                ],
                paymentForms:[ 
                ],
                cfdiTypes:[ 
                ],
                paymentsMethods:[ 
                ],
                clients: [
                ],
                iva: [
                    {text: "IVA 16%", value:"0.16"},

                ],
                currencies: [
                    { text: "MXN", value: "MXN" },
                    { text: "USD", value: "USD" },
                ]
            },

            actions: [
				{
					name: 'Borrar',
					icon: {
						color: 'normalText',
						icon: 'mdi-close-circle-outline'
					},
					disabled: false,
					type: 'method',   //  method, external, redirect
					action: 'deleteTableItem'
				},
			],
			tableProps: {
				headers: [
                     {
						text: 'Producto',
						align: 'left small-th-always',
						value: 'id_product',
                        sortable: false,
                        width: '15%',
						class: 'table-b-border black--text small-th-always'
					},
					{
						text: 'Cant.',
						align: 'left small-th-always',
						value: 'quantity',
						sortable: false,
                       
						class: 'table-b-border black--text small-th-always '
					},
                    {
						text: 'Unidad',
						align: 'left small-th-always',
						value: 'unitText',
						sortable: false,
						class: 'table-b-border black--text small-th-always'
					},
                    {
						text: 'Concepto',
						align: 'left',
						value: 'description',
						sortable: false,
                        width: '30%',
						class: 'table-b-border black--text small-th-always'
					},
                     {
						text: 'P.U.',
						align: 'center',
						value: 'unit_price',
                        width: '15%',
						sortable: false,
						class: 'table-b-border black--text small-th-always'
					},
                    {
						text: 'Impuestos',
						align: 'center',
						value: 'iva',
						sortable: false,
                        width: '14%',
						class: 'table-b-border black--text small-th-always'
					},
                     {
						text: 'Importe',
						align: 'right',
						value: 'total',
						sortable: false,
                        width: '10%',
						class: 'table-b-border black--text small-th-always'
					},
                   
					{
						text: '',
						align: 'right',
						sortable: false,
						value: 'actions',
						width: '2%',
						class: 'table-b-border black--text'
					}
				],
				items: this.values.items,
				search: '',
				loading: false,
                keyValue: 0,
                
			},

          
        }
    },
    computed: {
        
    },
    watch: { 

        [`values.cfdi_name_id`](v) {
            console.log(v);
            this.values.NameCodeProdServ="";
            const found = this.serverItems.cfdiTypes.find((x) => x.value == v);
            if(found != undefined)
                this.values.cfdi_type = found.normalVal??''
            
        },
      
        
    },
    mounted(){

        if(this.edit){
            this.loadItems();
        }
        
        this.getCustomers();
        this.getPaymentMethods();
        this.getReferences();
        this.getCfdiTypes();
        this.getPaymentForms();
        this.getProducts();

        
      
    },
    methods: {
        method_handler(object){
			this[object.methodName](object.parameters)
		},

        setTableClass(value, item = null){
            this.tableClass = value ? 'lockItem' : '';
            if(item != null)
                this.backupConcept = item.description;
        },
        closeItemDesc(item){
            this.setTableClass(false)
            item.parameters.showMenu = false;
            this.keyTable = this.keyTable + 1
            this.tableProps.keyValue = this.tableProps.keyValue + 1;
        },
        cancelItemDesc(item){
            this.setTableClass(false)
            item.description = this.backupConcept;
            item.parameters.showMenu = false;
            this.keyTable = this.keyTable + 1
            this.tableProps.keyValue = this.tableProps.keyValue + 1;
        },

        loadItems(){
            // let item = {
            //     "id_product": data.Folio,
            //     "description": data.Description,
            //     "tax_object": data.ObjetoImp,
            //     "unit_code": data.UnitCode,
            //     "unit_price": data.Price,
            //     "quantity": 1,
            //     "subtotal": data.Price,
            //     "discount": 0.0,
            //     "unitText": `${data.UnitCode} - ${data.Unit}`,
            //     "isTaxItem": this.checkTax(data.ObjetoImp),
            //     "taxes": [
                
            //     ],
            //     "total": data.Price,
            //     actions : JSON.parse(JSON.stringify(this.actions)),
            //     parameters: { id: data.Folio },
            // }

            this.values.items.forEach(item => {
                item[`unitText`] = `${item.unit_code} - ${item.unit}`;
                item[`unit`] = item.unit;
                item[`isTaxItem`] = this.checkTax(item.tax_object);
                item[`actions`] = JSON.parse(JSON.stringify(this.actions));
                item[`parameters`] = { id: item.id_product, showMenu:false };
            });

            this.keyTable = this.keyTable + 1
            this.tableProps.keyValue = this.tableProps.keyValue + 1;

            console.log(this.values.items)
        },

        calcItem(item){
            item.subtotal = item.unit_price * item.quantity;

            //process taxes
            item = this.processTaxes(item);

            console.log(item)
            return item;
        },
        processTaxes(item){
            item.total = item.subtotal;
            if(!item.isTaxItem) return item;

            item.taxes.forEach(tax => {
                console.log("si entra")
                if(tax.name == 'IVA'){
                    
                    tax.total = Utils.getIvaValue(item.subtotal, tax.rate);
                    tax.base = parseFloat(item.subtotal).toFixed(2);
                    item.total = parseFloat(item.total) + parseFloat(tax.total+"")
                    item.total = item.total.toFixed(2);

                    console.log(item)
                }
            });


            return item;
        },

        deleteTableItem(params){
            
            let pos = this.values.items.findIndex((x) => x.id_product == params.id)

            console.log(params, pos)
            this.values.items.splice(pos, 1);
        },
        
        addProduct(){
            console.log(this.productSelected)
            if(this.productSelected == undefined || this.productSelected == null || this.productSelected == '') return;

            const found = this.values.items.find((x) => x.id_product == this.productSelected);
            if(found != undefined) return;



         
            this.loadingProducts = true;
            this.$api.product.get(this.$store.state.business, this.productSelected)
                .then((resp) => {
                    console.log(resp);
                    this.insertProduct(resp.data);
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loadingProducts = false;
                })
            ;

        },

        insertProduct(data){
            let item = {
                "id_product": data.Folio,
                "description": data.Description,
                "tax_object": data.ObjetoImp,
                "unit_code": data.UnitCode,
                "unit_price": data.Price,
                "quantity": 1,
                "subtotal": data.Price,
                "discount": 0.0,
                "unitText": `${data.UnitCode} - ${data.Unit}`,
                "unit": data.Unit,
                "iva": '',
                "isTaxItem": this.checkTax(data.ObjetoImp),
                "taxes": [
                
                ],
                "total": data.Price,
                actions : JSON.parse(JSON.stringify(this.actions)),
                parameters: { id: data.Folio, showMenu:false },
            }
            //add tax
            if(this.checkTax(data.ObjetoImp)){
                data.Taxes.forEach(tax => {
                    item.taxes.push(
                        {
                            "total": 0,
                            "name": tax.Name,
                            "base": 0,
                            "rate": tax.Rate,
                            "is_retention": tax.IsRetention,
                            is_federal_tax: tax.IsFederalTax,
                        }
                    )
                });
                
            }else{
                data.Taxes.forEach(tax => {
                    item.taxes.push(
                        {
                            "total": 0,
                            "name": tax.Name,
                            "base": 0,
                            "rate": tax.Rate,
                            "is_retention": tax.IsRetention,
                            is_federal_tax: tax.IsFederalTax,
                        }
                    )
                });
            }

            // item.total = this.calcItemTotal(item);
            item = this.calcItem(item)

            this.values.items.push(item);
        },

        calcItemTotal(item){
            let iva = 0;
            let prodPrice = item.Price * item.quantity;
            if(this.checkTax(item.ObjetoImp)){
                iva = Utils.getIvaValue(data.Price, data.IVA) * item.quantity;
            }

            return prodPrice + iva;

        },

        checkTax(value){
          
            const numValue = parseInt(value);
            switch (numValue) {
                case '01':
                case '04':
                case '07':
                case '08':
                    return false;
                default:
                    return true;
            }
        },

        getCustomers()
        {
            this.loadingClients = true;
            this.$api.customer.getSelectCustomers(this.$store.state.business)
				.then((resp) =>{
					this.serverItems.clients = resp.data;
				})
				.catch((error) =>{
					console.log(error, "error");
				})
				.finally(() => {
                    this.loadingClients = false;
				})
			;
        },

        getReferences()
        {
            this.loadingReferences = true;
            this.$api.reference.getSelectReferences(this.$store.state.business)
                .then((resp) => {
                    this.serverItems.references = resp.data;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loadingReferences = false;
                })
            ;
        },

        getPaymentMethods()
        {
            this.loadingPM = true;
            this.$api.taxInvoice.paymentsMethods()
                .then((resp) => {
                    this.serverItems.paymentsMethods = resp.data.map((x) => {
                        return {text: `${x.Value} - ${x.Name}`, value: x.Value}
                    });
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loadingPM = false;
                })
            ;
        },

        getCfdiTypes()
        {
            this.loadingCfdiTypes = true;
            this.$api.taxInvoice.cfdiTypes()
                .then((resp) => {
                    this.serverItems.cfdiTypes = resp.data.map((x) => {
                        return {text: `${x.Value} - ${x.Name}`, value: x.NameId, normalVal: x.Value}
                    });
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loadingCfdiTypes = false;
                })
            ;
        },

        getPaymentForms()
        {
            this.loadingPaymentForms = true;
            this.$api.taxInvoice.paymentForms()
                .then((resp) => {
                    this.serverItems.paymentForms = resp.data.map((x) => {
                        return {text: `${x.Value} - ${x.Name}`, value: x.Value}
                    });
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loadingPaymentForms = false;
                })
            ;
        },


        getProducts()
        {
            this.loadingProducts = true;
            this.$api.product.selectData(this.$store.state.business)
                .then((resp) => {
                    this.serverItems.products = resp.data.map((x) => {
                        return{text:x.text, value: x.folio}
                    });
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.loadingProducts = false;
                })
            ;
        },

       
    }
}
</script>

<style lang="scss">

    .lockItem{
        pointer-events:none
    }

    .v-input.custom-sale-bill-input input {
        font-size: 0.9rem;
    }
    .v-input.custom-sale-bill-input .v-text-field__suffix {
        font-size: 0.9rem;
    }
    .sale-bill{

        &-textarea-input-btn{
            display: flex;
            justify-items: center;
            padding-bottom: 10px;
        }
        &-form-product-select-container{
            display: flex;
            width: 100%;

        }

        &-tax-item{
            margin: .5rem 0;
            display: flex;
            flex-direction: column;
            border: solid 1px var(--v-line-base);
            align-items: center;
            border-radius: .3rem;
            
        }

        &-tax-container{
            padding: 1px 5px;
            background-color: var(--v-inputsBackground-base);
        }

        &-tax-value{

        }
    }
</style>